import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Components/ContentItemStore";
import { setPostStyleGuideTheme, setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import { css } from "styled-components";

import "@wausauCustomBlueprint/Store/CutomReducer";


// import { addWidgetsFromContext } from '@insite/client-framework/Configuration';

// Load all custom widgets so they are included in the bundle.
// const widgets = require.context('./Components/Widgets', true, /\.tsx$/);

// This line is required if you have any custom widgets that need to be loaded
// or if you are specifying any widget extensions in your blueprint.
// const onHotWidgetReplace = addWidgetsFromContext(widgets);

const widgets = require.context("./Widgets", true, /\.tsx$/);
const onHotWidgetReplace = addWidgetsFromContext(widgets);
// ensure HMR works for custom widgets
if (module.hot) {
    module.hot.accept(widgets.id, () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
}

// load all pages. Without this they won't be included in the bundle
const pages = require.context("./Pages", true, /\.tsx$/);
const onHotPageReplace = addPagesFromContext(pages);
if (module.hot) {
    module.hot.accept(pages.id, () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/)));
}

// Enable hot module reloading for custom widgets.
// if (module.hot) {
//     module.hot.accept(widgets.id, () => onHotWidgetReplace(require.context('./Components/Widgets', true, /\.tsx$/)));
// }

// Load all handlers so they are included in the bundle.
// Recursively get all handler modifications
const handlers = require.context("./Handlers", true);
// Load the handler modifications.
handlers.keys().forEach(key => handlers(key));

// Load all the extensions to the base widgets. This includes style extensions.
const widgetExtensions = require.context("./WidgetExtensions", true);
widgetExtensions.keys().forEach(key => widgetExtensions(key));

setPreStyleGuideTheme({
    colors: {
        primary: {
            main: "#EE3D42",
        },
        secondary: {
            main: "#131B42",
        },
    },
    globalStyle: {
        css: css`
            .homepage-card {
                border: solid 1px red;
            }

            main {
                min-height: 70vh;
            }

            body {
                height: auto;
            }

            div[data-widget="Basic/PromotionsCard"] {
                height: 100%;
            }
            [class^="GridItemStyle"] {
                overflow-wrap: normal;
                word-break: normal;
            }
        `,
    },
});

setPostStyleGuideTheme({
    breakpoints: {
        keys: ["xs", "sm", "md", "lg", "xl"],
        values: [0, 576, 768, 992, 1200],
        maxWidths: [540, 540, 720, 960, 1440],
    },
});
